import React from "react";
import LlmChatPanel from "common_components/llm_chat";

const chatTabStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    flex: "1 1 auto",
  },
} as const;

function ChatTab(props) {
  return (
    <div style={chatTabStyles.container}>
      <LlmChatPanel
        {...props}
        documentHeadings={props.baseDocumentHeadings}
        compact={props.appType === "wordTaskpane"}
      />
    </div>
  );
}

export default ChatTab;
